// extracted by mini-css-extract-plugin
export default {"Container":"Slider_Container__8k74w","Content":"Slider_Content__063-o"};